import React from 'react'
import { NavLink } from 'react-router-dom'

import LightLogo from '@/assets/svgs/light-ms-logo.svg'
import DarkLogo from '@/assets/svgs/dark-ms-logo.svg'
import useThemeStore from '@/store/theme'
import { cn } from '@/utils/cn'

const navItems = [
  {
    key: 'home',
    label: '写作台',
    path: '/home',
    icon: 'outline-home',
    hilightIcon: 'fill-home',
  },
  {
    key: 'user-management',
    label: '用户管理',
    path: '/user-management',
    icon: 'outline-user-feather',
    hilightIcon: 'fill-user-feather',
  },
  // {
  //   key: 'learn-center',
  //   label: '学习中心',
  //   path: '/learn-center',
  //   icon: 'outline-education',
  //   hilightIcon: 'fill-education',
  // },
]

const LayoutSidebar: React.FC = () => {
  const { theme } = useThemeStore()
  const logoSrc = theme === 'dark' ? DarkLogo : LightLogo

  return (
    <aside className='flex flex-col h-screen w-[220px] shrink-0 bor-r border-stroke-2'>
      <div className='flex items-center h-64px px-3 bor-2 bor-b'>
        <img src={logoSrc} alt='logo' className='h-10' />
      </div>
      <nav className='flex flex-col gap-0.5 px-3 py-5'>
        {navItems.map(item => (
          <NavLink
            key={item.key ?? item.path}
            to={item.path ?? ''}
            className={({ isActive }) => cn(
              'group flex items-center gap-3 px-3 py-2 text-body-lg no-underline transition-200 rounded-3',
              isActive
                ? 'text-primary bg-overlay-1'
                : 'bg-transparent text-secondary hover:bg-overlay-1'
            )}
          >
            {({ isActive }) => (
              <>
                <iconpark-icon name={isActive ? item.hilightIcon : item.icon} size="18px" />
                <span className='flex-1 text-body-md-bold'>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
        <div className='bor-b border-stroke-1 my-3'></div>
        {/* <NavLink 
          key='trash'
          to='/trash'
          className={({ isActive }) => cn(
            'group flex items-center gap-3 px-3 py-2 text-body-lg no-underline transition-200 rounded-3',
            isActive
              ? 'bg-overlay-1 text-primary '
              : 'bg-transparent text-secondary hover:bg-overlay-1'
          )}
        >
          {({ isActive }) => (
            <>
              <iconpark-icon name={isActive ? 'fill-delete' : 'outline-delete'} size='18px' />
              <span className='flex-1 text-body-md-bold'>废纸篓</span>
            </>
          )}
        </NavLink> */}
      </nav>
    </aside>
  )
}

export default LayoutSidebar
